import { Chart, ChartConfiguration, ChartType } from 'chart.js';
import { getRsColors } from '../../utils/chartColors';

export const rsColors = getRsColors();

export const regionColors = [
  '#42b200', '#3838FF', '#9b9b9b', '#854cff', '#d97706',
  '#37a2da', '#ed3f8f', '#abb1ff', '#E85b4c', '#ffa600'
];

export function formatLabel(dateStr: string): string {
  // Parse date in UTC to avoid timezone issues
  const date = new Date(`${dateStr}T00:00:00Z`);
  const month = date.toLocaleString('en-US', { month: 'short', timeZone: 'UTC' });
  const year = date.getUTCFullYear().toString().slice(-2);
  return `${month}-${year}`;
}

export function createChart(
  canvas: HTMLCanvasElement | null,
  config: ChartConfiguration
): Chart | null {
  if (!canvas) return null;

  // Check if there's already a chart on this canvas and destroy it
  const existingChart = Chart.getChart(canvas);
  if (existingChart) {
    existingChart.destroy();
  }

  return new Chart(canvas, config);
}

export function destroyChart(canvas: HTMLCanvasElement | null): void {
  if (!canvas) return;

  const existingChart = Chart.getChart(canvas);
  if (existingChart) {
    existingChart.destroy();
  }
}

export function destroyAllChartsOnCanvas(canvasIds: string[]): void {
  canvasIds.forEach(canvasId => {
    const canvas = document.getElementById(canvasId) as HTMLCanvasElement;
    if (canvas) {
      const existingChart = Chart.getChart(canvas);
      if (existingChart) {
        existingChart.destroy();
      }
    }
  });
}

export const commonChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      labels: {
        color: rsColors.offWhite,
        usePointStyle: true,
        pointStyle: 'circle',
        padding: 20
      }
    },
    datalabels: {
      display: false // Disable all data labels
    }
  },
  scales: {
    x: {
      ticks: { color: rsColors.offWhite },
      grid: { color: '#4A4A4A', lineWidth: 0.3 },
      title: { color: rsColors.offWhite }
    },
    y: {
      ticks: { color: rsColors.offWhite },
      grid: { color: '#4A4A4A', lineWidth: 0.3 },
      title: { color: rsColors.offWhite }
    }
  }
};

export function getAxisColors(isDark: boolean = true) {
  return {
    tickColor: isDark ? rsColors.offWhite : '#1e2019',
    gridColor: isDark ? '#4A4A4A' : '#d0d3ce'
  };
}
